var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"index_box"}},[_c('v-header'),_c('div',{attrs:{"id":"main_box"}},[_c('router-view')],1),_c('v-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }